import { Injectable } from "@angular/core";
import { catchError, Observable, of, ReplaySubject, tap } from "rxjs";
import { environment } from "@env/environment";
import { HttpClient } from "@angular/common/http";
import { Product } from "./product.interface";

@Injectable()
export class ProductService {

    baseUrl = environment.settings_url + '/categories';
    private _myProduct: ReplaySubject<Product> = new ReplaySubject<Product>(1);
    private _product: ReplaySubject<Product> = new ReplaySubject<Product>(1);
    private _products: ReplaySubject<Product[]> = new ReplaySubject<Product[]>(1);

    set myProduct(value: Product) {
        this._myProduct.next(value);
    }

    get myProduct$() {
        return this._myProduct.asObservable();
    }

    set product(value: Product) {
        this._product.next(value);
    }

    get product$() {
        return this._product.asObservable();
    }

    set products(value: Product[]) {
        this._products.next(value);
    }

    get products$() {
        return this._products.asObservable();
    }

    // set productsLinked(value: product[]) {
    //     this._productsLinked.next(value);
    // }

    // get productsLinked$() {
    //     return this._productsLinked.asObservable();
    // }

    constructor(
        private _httpClient: HttpClient
    ) { }

    create(product: Product): Observable<Product> {
        return this._httpClient.post<Product>(`${this.baseUrl}`, product)
            .pipe(
                tap((product) => {
                    this.product = product;
                    return (product);
                }),
                catchError((error) => {
                    throw new Error(error);
                })
            );
    }

    getProduct(id: string): Observable<Product> {
        return this._httpClient.get<Product>(`${this.baseUrl}/${id}`)
            .pipe(
                tap((product) => {
                    this.product = product;
                    return (product);
                }),
                catchError((error) => {
                    throw new Error(error);
                })
            );
    }

    getproductsAll(): Observable<Product[]> {
        return this._httpClient.get<Product[]>(`${this.baseUrl}`)
            .pipe(
                tap((products) => {
                    this.products = products;
                    return (products);
                }),
                catchError(() => of([] as Product[]))
            );
    }

    loadProducts(): void {
        this.getproductsAll().subscribe();
    }
}